import { Injectable } from '@angular/core';

@Injectable()
export class StringUtilLibService {
  constructor() {}

  isEmpty(value: string): boolean {
    if (
      !value ||
      value?.trim() === '' ||
      value === 'null' ||
      value === null ||
      value === undefined
    ) {
      return true;
    }
    return false;
  }

  toTitleCase(value: string): string {
    if (!this.isEmpty(value)) {
      // return value.split(' ')
      //   .map(s => s.slice(0, 1).toUpperCase() + s.slice(1).toLowerCase())
      //   .join(' ');
      return value.charAt(0).toUpperCase() + value.slice(1);
    } else {
      return value;
    }
  }
}
